import { ThemeSelectors } from "@at/design-system-foundation";
import styled from "styled-components";

export const GalleryCloseButton = styled.button`
  display: flex;
  align-items: center;
  position: absolute;
  right: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  top: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  color: ${({ theme }) => ThemeSelectors.getWhite(theme)};
  padding: ${({ theme }) => `${ThemeSelectors.getGridUnit(theme)} `}
    ${({ theme }) => `calc(${ThemeSelectors.getGridUnit(theme)} * 2) `};
  border-radius: 6px;
  background-color: #3d3d3d;
  border: none;
  cursor: pointer;
  z-index: 1;

  span {
    margin-right: ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)};
  }

  path {
    fill: ${({ theme }) => ThemeSelectors.getWhite(theme)};
  }

  &:hover {
    background-color: ${({ theme }) =>
      ThemeSelectors.getActionHoverColor(theme)};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #29dcff;
  }
`;
